import type { Meta, StoryObj } from '@storybook/web-components';

import { createDocumentation, createComponent } from '@/globals/documentation/story';
import docs from './pn-level-up-modal-docs.json';

const { argTypes, textContent } = createDocumentation(docs);

const meta: Meta<HTMLPnLevelUpModalElement> = {
  title: 'Components/Widgets/Level up modal',
  parameters: {
    actions: {
    },
    docs: {
      description: {
        story: textContent
      }
    }
  },
  args: {
  open: true,
  instructionPhoneLineOne: 'Open your BankID app',
  instructionPhoneLineTwo: 'Click on the QR button in the app',
  instructionPhoneLineThree: 'Scan the QR code',
  headingText: 'Level up with BankID',
  endpoint: 'https://se-integration.postnord.com',
  outdatedQRMessage: 'The QR has expired',
  expiresInMessage: 'Expires in'
  },
  argTypes,
};

type Story = StoryObj<HTMLPnLevelUpModalElement>;

export default meta;

export const LevelUpModal: Story = {
  name: 'pn-level-up-modal',
  render: (args) => createComponent('pn-level-up-modal', args),
};
